import { useEffect, useRef, useState } from 'react';
import { API, Endpoints, Project } from '@brg/api';

export interface IContentViewFile {
    fileId: string;
    containerId: string;
    type: string;
    url: string;
    size: string;
    width: number;
    height: number;
    ratio: number;
    orientation: boolean;
    isDeleted: boolean;
    isNew: boolean;
    inProgress: boolean;
    crop: Record<string, any> | null; 
    localization: string;
    isOptimized: boolean;
    maskNumber: number | null;
    originalFileId: string | null;
}

export interface IContentViewItem {
    id: string;
    title: Array<{ lang: string; name: string }>;
    subTitle: Array<{ lang: string; name: string }>;
    link: string;
    files: IContentViewFile[];
    erid?: string;
    teamFullName?: string;
    teamName?: string;
    teamInn?: string;
}

export const useContentView = (project: Project | undefined) => {
    const [adItems, setAdItems] = useState<{ adTopItem: IContentViewItem | null; adBottomItem: IContentViewItem | null }>({ adTopItem: null, adBottomItem: null });
    const [contentPosition, setContentPosition] = useState<0 | 1>(0);
    
    const sentPositions = useRef<Set<string>>(new Set());
    const sensorRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        setContentPosition(0);
        setAdItems({ adTopItem: null, adBottomItem: null });
        sentPositions.current.clear();
    }, [project?.projectId]);


    useEffect(() => {
        const node = sensorRef.current;
        if (!node || !project?.projectId || contentPosition === 1) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setContentPosition(1);
                }
            },
            { 
                rootMargin: '1000px',
                threshold: 0 
            }
        );

        observer.observe(node);
        return () => observer.disconnect();
    }, [project?.projectId, contentPosition]);

    useEffect(() => {
        const projectId = project?.projectId;
        const tags = project?.tagsID;

        if (!projectId || !tags?.length) return;

        const cacheKey0 = `${projectId}:0:${tags.join(',')}`;
        if (!sentPositions.current.has(cacheKey0)) {
            sentPositions.current.add(cacheKey0);

            const fetchContentTop = async () => {
                try {
                    const response = await API.request()
                        .endpoint(Endpoints.additionalcontent)
                        .url('/api/Ad/AdView')
                        .addQuery('tagIds', tags)
                        .addQuery('position', '0')
                        .get()
                        .send();

                    const responseText = await response.text();
                    if (!responseText) return;

                    const data = JSON.parse(responseText);
                    setAdItems(prev => ({ ...prev, adTopItem: data }));
                } catch (error) {
                    sentPositions.current.delete(cacheKey0);
                    console.error('[useContentView] Error loading position 0:', error);
                }
            };

            fetchContentTop();
        }

        if (contentPosition === 1) {
            const cacheKey1 = `${projectId}:1:${tags.join(',')}`;
            if (!sentPositions.current.has(cacheKey1)) {
                sentPositions.current.add(cacheKey1);

                const fetchContentBottom = async () => {
                    try {
                        const response = await API.request()
                            .endpoint(Endpoints.additionalcontent)
                            .url('/api/Ad/AdView')
                            .addQuery('tagIds', tags)
                            .addQuery('position', '1')
                            .get()
                            .send();

                        const responseText = await response.text();
                        if (!responseText) return;

                        const data = JSON.parse(responseText);
                        setAdItems(prev => ({ ...prev, adBottomItem: data }));
                    } catch (error) {
                        sentPositions.current.delete(cacheKey1);
                        console.error('[useContentView] Error loading position 1:', error);
                    }
                };

                fetchContentBottom();
            }
        }

    }, [project?.projectId, project?.tagsID, contentPosition]);

    return { adItems, sensorRef, contentPosition };
};import { useEffect, useRef, useState } from 'react';
import { API, Endpoints, Project } from '@brg/api';

export interface IContentViewFile {
    fileId: string;
    containerId: string;
    type: string;
    url: string;
    size: string;
    width: number;
    height: number;
    ratio: number;
    orientation: boolean;
    isDeleted: boolean;
    isNew: boolean;
    inProgress: boolean;
    crop: Record<string, any> | null; 
    localization: string;
    isOptimized: boolean;
    maskNumber: number | null;
    originalFileId: string | null;
}

export interface IContentViewItem {
    id: string;
    title: Array<{ lang: string; name: string }>;
    subTitle: Array<{ lang: string; name: string }>;
    link: string;
    files: IContentViewFile[];
    erid?: string;
    teamFullName?: string;
    teamName?: string;
    teamInn?: string;
}

export const useContentView = (project: Project | undefined) => {
    const [adItems, setAdItems] = useState<{ adTopItem: IContentViewItem | null; adBottomItem: IContentViewItem | null }>({ adTopItem: null, adBottomItem: null });
    const [contentPosition, setContentPosition] = useState<0 | 1>(0);
    
    const sentPositions = useRef<Set<string>>(new Set());
    const sensorRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        setContentPosition(0);
        setAdItems({ adTopItem: null, adBottomItem: null });
        sentPositions.current.clear();
    }, [project?.projectId]);


    useEffect(() => {
        const node = sensorRef.current;
        if (!node || !project?.projectId || contentPosition === 1) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setContentPosition(1);
                }
            },
            { 
                rootMargin: '1000px',
                threshold: 0 
            }
        );

        observer.observe(node);
        return () => observer.disconnect();
    }, [project?.projectId, contentPosition]);

    useEffect(() => {
        const projectId = project?.projectId;
        const tags = project?.tagsID;

        if (!projectId || !tags?.length) return;

        const cacheKey0 = `${projectId}:0:${tags.join(',')}`;
        if (!sentPositions.current.has(cacheKey0)) {
            sentPositions.current.add(cacheKey0);

            const fetchContentTop = async () => {
                try {
                    const response = await API.request()
                        .endpoint(Endpoints.additionalcontent)
                        .url('/api/Ad/AdView')
                        .addQuery('tagIds', tags)
                        .addQuery('position', '0')
                        .get()
                        .send();

                    const responseText = await response.text();
                    if (!responseText) return;

                    const data = JSON.parse(responseText);
                    setAdItems(prev => ({ ...prev, adTopItem: data }));
                } catch (error) {
                    sentPositions.current.delete(cacheKey0);
                    console.error('[useContentView] Error loading position 0:', error);
                }
            };

            fetchContentTop();
        }

        if (contentPosition === 1) {
            const cacheKey1 = `${projectId}:1:${tags.join(',')}`;
            if (!sentPositions.current.has(cacheKey1)) {
                sentPositions.current.add(cacheKey1);

                const fetchContentBottom = async () => {
                    try {
                        const response = await API.request()
                            .endpoint(Endpoints.additionalcontent)
                            .url('/api/Ad/AdView')
                            .addQuery('tagIds', tags)
                            .addQuery('position', '1')
                            .get()
                            .send();

                        const responseText = await response.text();
                        if (!responseText) return;

                        const data = JSON.parse(responseText);
                        setAdItems(prev => ({ ...prev, adBottomItem: data }));
                    } catch (error) {
                        sentPositions.current.delete(cacheKey1);
                        console.error('[useContentView] Error loading position 1:', error);
                    }
                };

                fetchContentBottom();
            }
        }

    }, [project?.projectId, project?.tagsID, contentPosition]);

    return { adItems, sensorRef, contentPosition };
};